function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.6 7.5c-5.7 2-8.7 4.5-11.6 9.6l-2.5 4.4v469L9 495c2.8 4.9 7.3 8.4 12.9 10 5 1.4 463.2 1.4 468.2 0 5.6-1.6 10.1-5.1 12.9-10l2.5-4.5v-469L503 17c-2.8-4.9-7.3-8.4-12.9-10-2.4-.6-82.8-1-234.6-1-195.7.1-231.6.3-234.9 1.5zM133 176v162h38v160H97.8c-82 0-78.4.3-82-7-1.7-3.3-1.8-16.6-1.8-235s.1-231.7 1.8-235c3.5-7.1 2.3-7 63-7H133v162zm164 0v162l18.8.2 18.7.3v159l-77.7.3-77.8.2V338h36V14h82v162zM491 15.8c2 1 4.2 3.2 5.2 5.2 1.7 3.3 1.8 16.6 1.8 235s-.1 231.7-1.8 235c-3.6 7.3-.1 7-81.4 7H342V338h37V14h54.3c49.6 0 54.5.2 57.7 1.8z"
});

function SvgSafariPinnedTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682.667,
    height: 682.667,
    viewBox: "0 0 512 512"
  }, props), _ref);
}

export default __webpack_public_path__ + "safari-pinned-tab.25ea8629a265fdabc881658a396cc020.svg";
export { SvgSafariPinnedTab as ReactComponent };